/**
 * reports service
 */

import Resource from './resource'

export default new Resource('reports')



// WEBPACK FOOTER //
// ./src/libraries/services/reports.js